/* eslint-disable */
/* global Popper */
/**
 * Light-weight callouts, similar to bootstrap popovers.
 *
 * Requires popper.js
 *
 * @example
 *   <button data-callout="#my_callout">Click me</button>
 *   <div class="callout" id="my_callout">
 *     <h3>This is a header</h3>
 *     <button>This is a call to action</button>
 *   </div>
 *
 * TODO:
 *   More placements (top, left, right, maybe bottom-left, etc?)
 *   Events (Similar to the bootstrap popover events)
 *   Configurable Popper.js options
 *   Handle title attributes?
 */

; (function ($) {
  'use strict';

  // All of these defaults can be kebab cased and used as data-attributes
  // params > data attributes > defaults
  var defaults = {
    addClose: true, // Add close button
    closeText: 'Close',
    closeOnClick: false,// Close tooltip if any part is clicked
    addArrow: true, // Add arrow element
    // adjustArrow:  true, // Attempt to keep arrow centered on trigger element
    // boundary:     'viewport', // Attempt to keep tip within viewport
    placement: 'bottom',
    show: false, // Show after we create the object?
    trigger: 'click', // Default toggle event. null to disable toggle on click
    toggle: true, // Toggle show/hide when trigger is activated
    animation: false, // Add animation classes when showing
    backdrop: false, // Show a clickable backdrop under the callout
    tooltipTarget: null, // Allows tooltips to have html content
    hoverable: false, // Show callout on hover (Not full implemented)
    tooltipIsLabel: false, // The tooltip is to be used as the element's primary label (its accessible name)
    callout: null // selector, dom element, etc to use as callout element
  };

  var name = 'callout';

  var dataObjectName = name + '-object';

  var now = Date.now();

  // keep track of shown tooltip so multiple can't show
  var showingTooltip;

  // Class
  var Callout = function ($el, params) {
    var self = this;
    this.$el = $el;
    this.tooltip = false;

    // Save the object to the dom elemnt's data so we can get it later
    $el.data(dataObjectName, this);

    // get data- options
    var domParams = {};
    for (var camel in defaults) {
      if (!defaults.hasOwnProperty(camel)) continue;

      var kebab = camelToKebab(camel);
      var value = $el.data(kebab);

      if (typeof value !== 'undefined') {
        domParams[camel] = value;
      }
    }

    var options = $.extend({}, defaults, domParams, params);
    this.options = options;

    // Set up callout dom element
    var callout = options.callout || $el.data('callout');
    var $callout;

    // Tooltip setup
    if (callout === 'tooltip') {
      if (options.tooltipTarget) {
        $callout = $(options.tooltipTarget).first();
      } else {
        $callout = $('<span class="zrCallout-tooltip"></span>').text($el.attr('title') || $el.attr('data-title'));
      }

      $callout.css('visibility', 'hidden');
      now++;
      var id = 'zrCallout-' + now;
      $callout.attr({
        id: id,
        role: 'tooltip'
      });

      // if tooltip is element's primary label, mark it as such
      if (options.tooltipIsLabel) {
        $el.attr('aria-labelledby', id);
      } else {
        // otherwise, it provides additional descriptive text
        $el.attr('aria-describedby', id);
      }

      $el.attr('title', '').attr('data-title', '');

      options.addClose = false;

      this.tooltip = true;
      // $el.after($callout);
      $callout.appendTo(document.body)

      // Watch for changes to title.
      var observer = new MutationObserver(function () {
        // if title or data-title attribute has been updated with new text (i.e. not cleared by this function)
        if ($el.attr('title').length || $el.attr('data-title').length) {
          $callout.text($el.attr('title') || $el.attr('data-title'));
          $callout.append($callout.data(dataObjectName + '-arrow'));

          // clear title attributes after a change so regular hover text does not appear
          $el.attr('title', '').attr('data-title', '');
        } else {
          // if both title and data-title are empty, toggle the callout
          self.toggle();
        }
      });

      observer.observe($el.get(0), {
        attributes: true,
        attributeFilter: ['title', 'data-title']
      });
      // Callout setup
    } else {
      $callout = $(callout)
        .attr('tabIndex', -1)
        // Allow esc to close
        .on('keyup', function (e) {
          if (e.keyCode === 27) {
            self.hide();
          }
        });

      if (options.hoverable) {
        $callout = $(callout)
          .attr('data-hoverable', 'true');
      }

      // TODO: go back to just using a string instead of an array here
      // We can't really have one Popper owned by multiple triggers so we'll destroy old ones
      var callouts = $callout.data(dataObjectName + '-callouts') || [];

      for (var i = 0, l = callouts.length, co; i < l; i++) {
        co = callouts[i];
        co.hide();
        co.popper.destroy();
        co.$el.data(dataObjectName, null);
        delete callouts[i];
      }

      callouts = [];

      callouts.push(this);
      $callout.data(dataObjectName + '-callouts', callouts);

      // Add close button
      // Don't add more than one close button
      var $close = $callout.data(dataObjectName + '-close') || $('<button class="close" data-close="callout">' + options.closeText + '</button>');
      $callout.data(dataObjectName + '-close', $close);
      $callout.append($close);

      if (!options.addClose) {
        $close
          .addClass('visually-hidden');
      }

      // Backdrop
      if (options.backdrop) {
        $callout
          .attr({ role: 'dialogue' })
          // Move to the end of the body to avoid z-index issues
          .appendTo(document.body)
          .css({
            zIndex: 1010 // based on zr nav TODO: find a better way to set z-index
          });

        this.$backdrop = $('<div/>')
          .addClass(dataObjectName + '-backdrop')
          .css({
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1009 // based on zr nav TODO: find a better way to set z-index
          })
          .hide()
          .appendTo(document.body)
          .on('click', function () {
            self.hide();
          });

        // If they tab to this, close the callout and focus the trigger
        var $focusBounce = $('<span/>')
          .text('Focus dialogue...')
          .addClass(dataObjectName + '-bounce')
          .appendTo($callout)
          .attr({ tabindex: 0 })
          .css({
            height: '1px',
            width: '1px',
            opacity: 0,
            position: 'absolute'
          })
          .on('focus', function () {
            $callout.focus();
          });
      }
    }

    this.$callout = $callout;

    var padding = scrollbarWidth || 15;

    // Set up Popper
    var popperOptions = {
      placement: options.placement,
      positionFixed: true,
      eventsEnabled: true,
      //,
      // onCreate
      // onUpdate
      //modifiers: {
      //flip: Popper.Defaults.modifiers.flip
      //}
      modifiers: {
        preventOverflow: {
          enabled: true,
          boundariesElement: 'window',
          padding: padding,
          fn: function (data, options) {
            var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            data = Popper.Defaults.modifiers.preventOverflow.fn(data, options);
            if (data.offsets.popper.left + data.offsets.popper.width > w + padding) {
              data.offsets.popper.left = w - data.offsets.popper.width - padding;
            }

            return data;
          }
        },
        /*flip: {
          behavior: ['right', 'bottom-end', 'bottom', 'left', 'top'],
          boundariesElement: 'viewport'
        },*/
        keepTogether: {
          enabled: true
        }
      }
    };

    // Add arrow
    if (options.addArrow) {
      // Don't add more than one arrow
      var $arrow = $callout.data(dataObjectName + '-arrow') || $('<span class="arrow"></span>');
      $callout.data(dataObjectName + '-arrow', $arrow);
      $callout.append($arrow);
      popperOptions.modifiers.arrow = {
        element: $arrow[0]
      }
    }

    var popper = new Popper($el[0], $callout[0], popperOptions);

    // Save popper object for later (events)
    this.popper = popper;

    if (options.show) {
      this.show();
    }

    // Events

    // Making sure the popper is positioned properly when clicked
    $el.on('click', function () {
      setTimeout(function () {
        self.popper.update();
      }, 0);
    });


    if (!this.tooltip) {
      // Close button
      $callout.on('click', '[data-close="callout"]', function (e) {
        e.preventDefault();
        self.hide(true);
      });

      // Toggle
      if (options.trigger) {
        var toggleTryTo;
        $el.on(options.trigger, function () {
          if (self.showing) {
            if (options.toggle) {
              self.hide();
            } else {
              $callout.removeClass('toggle-try');
              clearTimeout(toggleTryTo);

              setTimeout(function () {
                $callout.addClass('toggle-try');
                toggleTryTo = setTimeout(function () {
                  $callout.removeClass('toggle-try');
                }, 1000);
              }, 0);
            }
          } else {
            self.show();
          }
        });
      }

      // Click callout to close
      if (options.closeOnClick) {
        $callout.on('click', function (e) {
          // Don't close if clicking interactive elements
          if ($(e.target).is('a, button')) return;

          self.hide();
        });
      }
    }

  };

  // Show callout element
  Callout.prototype.show = function () {
    var $callout = this.$callout;
    var self = this;

    // All shared triggers' callouts will be set to hidden
    var callouts = $callout.data(dataObjectName + '-callouts');
    for (var callout in callouts) {
      if (!callouts.hasOwnProperty(callout) || self === callouts[callout]) continue;
      callouts[callout].hide();
    }

    this.showing = true;

    this.$el.addClass('showing');

    if (this.tooltip) {
      // Close showing tooltips
      if (showingTooltip && self !== showingTooltip) {
        showingTooltip.hide();
      }

      showingTooltip = this;

      $callout.addClass('showing');
      setTimeout(function () {
        self.popper.update();
        $callout.css('visibility', '');
      }, 0)
    } else {
      if (this.$backdrop) {
        this.$backdrop.show();

        // Trap tabbing
        $(document)
          .off('focusin') // Guard against infinite focus loop
          .on('focusin', function (event) {
            if (document !== event.target &&
              self.$callout[0] !== event.target &&
              self.$el[0] !== event.target && // TODO: What if the trigger is the only other element on the page?
              self.$callout.has(event.target).length === 0) {
              // We need to focus the trigger before the callout
              // because the browser won't scroll back up
              // since the callout is positioned via transforms.
              self.$el.focus();
              self.$callout.focus();
            }
          });
      }

      $callout.show()

      this.popper.update();

      // Focus needs to happen after show + popper update or it breaks things
      if (!this.options.hoverable) {
        $callout.focus();
      }

      if (this.options.animation) {
        $callout.addClass('toggle-showing-start');
        setTimeout(function () {
          $callout.addClass('toggle-showing').removeClass('toggle-showing-start');
          setTimeout(function () {
            $callout.removeClass('toggle-showing');
          }, 1000);
        }, 0);
      }
    }

    this.$el.trigger('show.zr.callout');
  };

  // Hide callout element
  Callout.prototype.hide = function (closeButton, noFocus) {
    // Skip already hidden tooltips since there can be side effects
    if (!this.showing) {
      return;
    }

    this.showing = false;

    this.$el.removeClass('showing');

    if (this.tooltip) {
      this.$callout.removeClass('showing');
      showingTooltip = null;
    } else {
      this.$callout.hide();

      if (this.$backdrop) {
        $(document).off('focusin');
        this.$backdrop.hide();

        // If something is manually hiding, they can take care of focus
        if (!noFocus) {
          this.$el.focus();
        }
      }
    }

    this.$el.trigger('hide.zr.callout', { closeButton: closeButton });
  };

  // Show or hide callout element
  Callout.prototype.toggle = function () {
    if (this.showing) {
      this.hide(undefined, true);
    } else {
      this.show();
    }
  };

  // Private methods

  // Get or make associated Callout (class) object
  var getObj = function ($this, params) {
    var obj = $this.data(dataObjectName);

    if (!obj) {
      obj = new Callout($this, params);
    }

    return obj;
  };

  // Plugin
  $.fn.zrCallout = function (params, allowFocus) {
    if (typeof params === 'string') {
      if (params === 'show') {
        this.each(function () {
          var obj = getObj($(this), { show: true });
          obj.show();
        });
      } else if (params === 'hide') {
        this.each(function () {
          var obj = getObj($(this));
          obj.hide(undefined, !allowFocus);
        });
      } else if (params === 'toggle') {
        this.each(function () {
          var obj = getObj($(this));
          obj.toggle();
        });
      }
    } else {
      this.each(function () {
        getObj($(this), params);
      });
    }

    return this;
  };

  // Helpers

  // https://gist.github.com/nblackburn/875e6ff75bc8ce171c758bf75f304707
  // Convert camelCase to kebab-case
  function camelToKebab(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }

  // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
  // Get scrollbar width so we can tell Popper to not allow tooltips to fall under it
  function getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
  }

  var scrollbarWidth = getScrollbarWidth();
}(window.Zepto || window.jQuery || window.$));
